import { render, staticRenderFns } from "./StackEdit.vue?vue&type=template&id=570e9fec&scoped=true&"
import script from "./StackEdit.vue?vue&type=script&lang=js&"
export * from "./StackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e9fec",
  null
  
)

export default component.exports